import {useEffect, useState} from 'react';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import axios from '../../axios';
import M from 'materialize-css';
import { useNavigate } from 'react-router-dom';
import { Switch } from '@headlessui/react';
import usePermisos from '../../hooks/usePermisos';
import NoPermissions from '../NoPermissions/NoPermissions';
import Loader from '../../Layout/Loaders/Loader';
import {StarIcon} from '@heroicons/react/24/solid';
import SucursalSelector from './SucursalSelector';

const errorMessages = {
    nombre_producto:"nombre del producto",
    precio_unidad:"precio",
    duracion_aproximada:"duracion",
    activo:"activo",
    dias_preparacion:"días preparacion",
    dias_entrega:"días entrega"
}

const PERMISOS_REQUERIDOS = ['products_create'];

const New = () => {
    const [servicio, setServicio] = useState({
        nombre_producto: "",
        precio_unidad: "",
        duracion_aproximada: 0,
        descripcion: "",
        activo: true,
        visible_web: false,
        solo_presencial: false,
        dias_preparacion: 0,
        dias_entrega: 0
    });
    // Estado para sucursales asignadas
    const [sucursalesAsignadas, setSucursalesAsignadas] = useState([]);
    const [sucursalesDisponibles, setSucursalesDisponibles] = useState([]);
    const navigate = useNavigate();
    const [validate, setValidate] = useState({
        nombre_producto: true,
        precio_unidad: true,
        duracion_aproximada: true,
    });
    const { permisos, loading: loadingPermisos, tienePermiso } = usePermisos(PERMISOS_REQUERIDOS);
   

    useEffect(() => {
      axios.get('api/sucursals')
        .then(res => {
          setSucursalesDisponibles(res.data);
        })
        .catch(e => {
          M.toast({ html: '<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>Error al cargar sucursales</span>', classes: "error-notify" });
        });
        
    }, []);


    const _saveServicio = (e) => {
        e.preventDefault();
        // Incluye sucursalesAsignadas en el payload
        axios.post('api/products', { ...servicio, sucursales: sucursalesAsignadas })
            .then(res => {
                M.toast({ html: '<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>servicio creada exitosamente</span>', classes: "success-notify" });
                setTimeout(() => {
                    navigate("/admin/servicios");
                }, 2000);
            })
            .catch(e => {
                if (e.message && e.response?.data?.errors) {
                    let errores = e.response.data.errors;
                    for (var key in errores) {
                        setValidate((prev) => ({ ...prev, [key]: false }));
                        let mensaje = `El campo ${errorMessages[key]} es obligatorio. Agregalo para guardar el servicio`;
                        M.toast({ html: '<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>' + mensaje + '</span>', classes: "error-notify" });
                    }
                }
            });
    };
    return (
        <div>
            <div className="container-admin-menu">
                <Breadcrumb />
            </div>
            <div className="container-admin-container">
                <div className="container-admin bg-white rounded-lg shadow-md">
                    <h5 className="p-5 text-xl font-bold flex items-center justify-start"> <StarIcon className="inline-block h-6 w-6 mr-2" /> Nuevo Servicio</h5>
                    {loadingPermisos ? (
                        <Loader />
                    ) : !tienePermiso('products_create') ? (
                        <NoPermissions />
                    ) : (
                        <form onSubmit={_saveServicio} className="grid grid-cols-12 gap-4 px-5 pb-5" id="general-form">
                            {/* Nombre */}
                            <div className="col-span-12 md:col-span-6">
                                <div className="flex flex-col gap-1">
                                    <label htmlFor="name" className="text-sm font-medium text-gray-600">Nombre del Servicio *</label>
                                    <input
                                        id="name"
                                        type="text"
                                        className="dento-input"
                                        value={servicio.nombre_producto}
                                        onChange={(e) => setServicio({ ...servicio, nombre_producto: e.target.value })}
                                    />
                                    {!validate.nombre_producto && (
                                        <span className="text-sm text-red-500">El nombre del servicio es obligatorio.</span>
                                    )}
                                </div>
                            </div>
                            {/* Precio unidad */}
                            <div className="col-span-12 md:col-span-3">
                                <div className="flex flex-col gap-1">
                                    <label htmlFor="precio" className="text-sm font-medium text-gray-600">Precio unidad *</label>
                                    <input
                                        id="precio"
                                        type="number"
                                        step="0.01"
                                        className="dento-input"
                                        value={servicio.precio_unidad}
                                        onChange={(e) => setServicio({ ...servicio, precio_unidad: e.target.value })}
                                    />
                                    {!validate.precio_unidad && (
                                        <span className="text-sm text-red-500">El precio es obligatorio.</span>
                                    )}
                                </div>
                            </div>
                            {/* Duración aproximada */}
                            <div className="col-span-12 md:col-span-3">
                                <div className="flex flex-col gap-1">
                                    <label htmlFor="duracion_aproximada" className="text-sm font-medium text-gray-600">Duración (min) *</label>
                                    <input
                                        id="duracion_aproximada"
                                        type="number"
                                        step="any"
                                        min="0"
                                        className="dento-input"
                                        value={servicio.duracion_aproximada}
                                        onChange={(e) => setServicio({ ...servicio, duracion_aproximada: e.target.value })}
                                    />
                                    {!validate.duracion_aproximada && (
                                        <span className="text-sm text-red-500">La duración es obligatoria.</span>
                                    )}
                                </div>
                            </div>
                            {/* Días de entrega */}
                            <div className="col-span-12 md:col-span-3">
                                <div className="flex flex-col gap-1">
                                    <label htmlFor="dias_entrega" className="text-sm font-medium text-gray-600">Días de entrega</label>
                                    <input
                                        id="dias_entrega"
                                        type="number"
                                        min="0"
                                        className="dento-input"
                                        value={servicio.dias_entrega}
                                        onChange={(e) => setServicio({ ...servicio, dias_entrega: e.target.value })}
                                    />
                                </div>
                            </div>
                            {/* Días de preparación */}
                            <div className="col-span-12 md:col-span-3">
                                <div className="flex flex-col gap-1">
                                    <label htmlFor="dias_preparacion" className="text-sm font-medium text-gray-600">Días de preparación</label>
                                    <input
                                        id="dias_preparacion"
                                        type="number"
                                        step="any"
                                        min="0"
                                        className="dento-input"
                                        value={servicio.dias_preparacion}
                                        onChange={(e) => setServicio({ ...servicio, dias_preparacion: e.target.value })}
                                    />
                                </div>
                            </div>
                            {/* textarea descripción */}
                            <div className="col-span-12">
                                <div className="flex flex-col gap-1">
                                    <label htmlFor="description" className="text-sm font-medium text-gray-600">Descripción</label>
                                    <textarea
                                        id="description"
                                        className="dento-input min-h-40 resize-vertical"
                                        value={servicio.descripcion}
                                        onChange={(e) => setServicio({ ...servicio, descripcion: e.target.value })}
                                    />
                                </div>
                            </div>
                            {/* Estado del servicio (Switch) */}
                            <div className="col-span-12 md:col-span-3 flex items-center">
                                <div className="flex flex-col gap-1 w-full">
                                    <label htmlFor="activo" className="text-sm font-medium text-gray-600">Estado del servicio</label>
                                    <Switch
                                        checked={!!servicio.activo}
                                        onChange={v => setServicio({ ...servicio, activo: v })}
                                        className={`${servicio.activo ? 'bg-blue-600' : 'bg-gray-300'} relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
                                    >
                                        <span className="sr-only">Activo</span>
                                        <span
                                            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${servicio.activo ? 'translate-x-6' : 'translate-x-1'}`}
                                        />
                                    </Switch>
                                    <span className="text-xs text-gray-500 mt-1">{servicio.activo ? 'Activo' : 'Inactivo'}</span>
                                </div>
                            </div>
                            {/* Estado de visibilidad en web (Switch) */}
                            <div className="col-span-12 md:col-span-3 flex items-center">
                                <div className="flex flex-col gap-1 w-full">
                                    <label htmlFor="visible_web" className="text-sm font-medium text-gray-600">Visible en web</label>
                                    <Switch
                                        checked={!!servicio.visible_web}
                                        onChange={v => setServicio({ ...servicio, visible_web: v })}
                                        className={`${servicio.visible_web ? 'bg-blue-600' : 'bg-gray-300'} relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
                                    >
                                        <span className="sr-only">Visible en web</span>
                                        <span
                                            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${servicio.visible_web ? 'translate-x-6' : 'translate-x-1'}`}
                                        />
                                    </Switch>
                                    <span className="text-xs text-gray-500 mt-1">{servicio.visible_web ? 'Visible' : 'No visible'}</span>
                                </div>
                            </div>
                            {/* Solo presencial - no requiere cita (Switch) */}
                            <div className="col-span-12 md:col-span-3 flex items-center">
                                <div className="flex flex-col gap-1 w-full">
                                    <label htmlFor="solo_presencial" className="text-sm font-medium text-gray-600">Solo presencial</label>
                                    <Switch
                                        checked={!!servicio.solo_presencial}
                                        onChange={v => setServicio({ ...servicio, solo_presencial: v })}
                                        className={`${servicio.solo_presencial ? 'bg-orange-500' : 'bg-gray-300'} relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2`}
                                    >
                                        <span className="sr-only">Solo presencial</span>
                                        <span
                                            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${servicio.solo_presencial ? 'translate-x-6' : 'translate-x-1'}`}
                                        />
                                    </Switch>
                                    <span className="text-xs text-gray-500 mt-1">{servicio.solo_presencial ? 'No requiere cita' : 'Requiere cita'}</span>
                                </div>
                            </div>
                            {/* Sucursales asignadas */}
                            <div className="col-span-12">
                                <SucursalSelector
                                    sucursalesDisponibles={sucursalesDisponibles}
                                    sucursalesAsignadas={sucursalesAsignadas}
                                    onChange={setSucursalesAsignadas}
                                />
                            </div>
                            {/* Botón guardar */}
                            <div className="col-span-12 pt-6 flex justify-end">
                                <button
                                    className="inline-flex items-center gap-2 px-6 py-2.5 bg-blue-600 text-white hover:bg-blue-700 font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                    type="submit"
                                >
                                    Guardar
                                    <span className="material-icons">send</span>
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default New;